export enum ReportAction {
  createReport = "createReport",
  generateReport = "generateReport",
  refreshReport = "refreshReport",
  exportReportPrices = "exportReportPrices",
  editReportPrices = "editReportPrices",
  editReport = "editReport",
  deleteReport = "deleteReport",
  getReports = "getReports",
  getReport = "getReport",
  getReportNotes = "getReportNotes",
  createReportNote = "createReportNote",
  deleteReportNote = "deleteReportNote",
}
